import { LockClosedIcon } from "@heroicons/react/20/solid";
import { ProjectsContentCard } from "./ProjectsContentCard";
import React, { useState, useEffect } from "react";
import WhenfinLogo from "./assets/whenfin.png";
import { ProjectTabs } from "./ProjectTabs";

function isProtectedProject(projectIdentifier) {
  return (
    ["FileCompressor", "DistributedComputing"].indexOf(projectIdentifier) >= 0
  );
}

export const ProjectsCard = ({
  authenticatedResources,
  setProjectsVisible, // Make sure this is passed from the parent
}) => {
  const [projectIdentifier, setProjectIdentifier] = useState("Tutorial");
  const [projectState, setProjectState] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);

  useEffect(() => {
    const token = authenticatedResources
      ? authenticatedResources.access_token
      : undefined;
    if (!token && isProtectedProject(projectIdentifier)) {
      return;
    }
    if (projectIdentifier == "Tutorial") return;
    setCurrentFile("README.md");
    const update_content = async () => {
      const whenfinResponse = await fetch("https://api.l-uca.com/get_project", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
          project: projectIdentifier,
        }),
      });
      if (whenfinResponse.status == 200) {
        const response = await whenfinResponse.json();
        setProjectState(response);
        console.log(response);
      }
    };
    update_content();
  }, [projectIdentifier]);

  return (
    <>
      <div className="w-full flex-grow relative max-w-4xl sm:w-[700px] flex flex-col overflow-scroll">
        {authenticatedResources || !isProtectedProject(projectIdentifier) ? (
          <div className="flex-grow overflow-scroll hidden sm:block">
            <ProjectsContentCard
              projectState={projectState}
              setProjectIdentifier={setProjectIdentifier}
              projectIdentifier={projectIdentifier}
              setCurrentFile={setCurrentFile}
              authenticatedResources={authenticatedResources}
            />
          </div>
        ) : (
          <div className="hidden sm:flex bg-white flex-grow h-full w-full items-center justify-center flex-col gap-4 -mt-8">
            <LockClosedIcon className="w-8 h-8 text-amber-500" />
            <div className="flex flex-col items-center text-center">
              <h2 className="text-lg font-semibold">
                This project is protected
              </h2>
              <p className="max-w-[65%]">Use the link on my resume to unlock</p>
            </div>
          </div>
        )}
      </div>

      {projectIdentifier != "Tutorial" && (
        <button
          onClick={() => setProjectIdentifier("Tutorial")}
          className="absolute w-fit bottom-3 right-6 px-4 py-2 bg-gray-200 hover:bg-red-500 hover:text-white transition-colors rounded-lg font-semibold shadow border border-gray-400"
          title="Exit project viewer"
        >
          Choose other project
        </button>
      )}
    </>
  );
};
